export default __webpack_public_path__ + "static/media/Address.03328906.svg";